import { FoodIngredientsModel } from "./FoodIngredientsModel";
import { FoodsImagesModel } from "./FoodsImagesModel";


export class FoodsModel{
    id?: number;
    nameAr?:string;
    nameEn?:string;
    nameFr?:string;
    descriptionAr?:string;
    descriptionEn?:string;
    descriptionFr?:string;
    countryId?: number;
    averageStar?: number;
    foodsImagesList?:FoodsImagesModel[]
    foodIngredientsList?:FoodIngredientsModel[]
    images?:string;
    countryNameAr?:string;
    countryNameEn?:string;


    constructor(item?:FoodsModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.images = item.images? item.images:'';
        this.nameAr = item.nameAr? item.nameAr:'';
        this.nameEn = item.nameEn? item.nameEn:'';
        this.nameFr = item.nameFr? item.nameFr:'';
        this.descriptionAr = item.descriptionAr? item.descriptionAr:'';
        this.descriptionEn = item.descriptionEn? item.descriptionEn:'';
        this.descriptionFr = item.descriptionFr? item.descriptionFr:'';
        this.countryId = item.countryId? item.countryId:0;
        this.averageStar = item.averageStar? item.averageStar:0;
        this.foodsImagesList = item.foodsImagesList? item.foodsImagesList:[];
        this.foodIngredientsList = item.foodIngredientsList? item.foodIngredientsList:[];
        this.countryNameAr = item.countryNameAr? item.countryNameAr:'';
        this.countryNameEn = item.countryNameEn? item.countryNameEn:'';

    }

}